<template>
<div>
    <div class="breadcrumb-list">
        <ol class="breadcrumb">
            <li class="breadcrumb-item active">Profile</li>
        </ol>
        <div class="emp-button btn-align text-right" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
                    <button type="button" data-toggle="modal" data-target="#creat-employee" class="btn btn-outline-primary" >Create New Employee</button>
        </div>
    </div>
    <div class="main-box two-column">
      <employee-sidebar v-bind:employeeData="employeeData"></employee-sidebar>

    <div class="emplyee-info-wrp">
      <div class="personal-info-page">
        <div class="employment-details">
            <div class="info-head">
                <h5>Employment Benefits</h5>
                <span>To be completed by a manager</span>
                <button class="btn btn-outline-primary" data-toggle="modal"

                  data-target="#add-company-benefit"
                >Assign Benefit</button>
            </div>
            <div class="row justify-content-center">
              <div class="col-xl-10 col-md-12">
                  <div class="table-scroll employee-benifits">
                      <table class="table">
                          <thead class="table-head">
                              <tr>
                                  <th scope="col">Description</th>
                                  <th scope="col">Amount</th>
                                  <th scope="col">Used</th>
                                  <th scope="col">Remaining</th>
                                  <th>Action</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(benefit,index) of employeeAllownces" :key="index">
                                  <td>
                                      <div class="form-control text-capitalize">
                                          {{ benefit.companyBenefit.name }}
                                      </div>
                                  </td>
                                  <td>
                                      <div class="form-control"> {{ benefit.benefits_amount }} </div>
                                  </td>
                                <td>

                                </td>
                                <td></td>
                                  <td>
                                    <a
                                      href="javascript:void(0)"
                                      class="edit-icon flex-shrink-0 pl-2"
                                      data-toggle="modal"
                                      data-target="#benefit-modal"
                                      @click="openBenefitModal(benefit.id)"
                                    ><i class="ico-pencil"></i
                                    ></a>
                                    <a href="javascript:void(0)" v-on:click="delAllownce(benefit.employee_id,benefit.id)"><i class="ico ico-delete"></i></a>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>
    </div>



      <!-- assign benefit modal -->
      <div
      class="modal fade write-msg-model creat-employee-modal"
      id="add-company-benefit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="write-msg-modelLabel"
      aria-hidden="true"
      >
          <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <div class="modal-title">
                          <h5>Assign Benefit</h5>
                      </div>
                      <button
                              type="button"
                              class="close"
                              ref="closeModal"
                              data-dismiss="modal"
                              aria-label="Close"
                      >
                          <span class="ico-cross"></span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="">
                          <div class="inputs-wrapper">
                              <div class="inputs-holder">
                                  <ul class="emp-job-list">
                                    <li v-for="benefit of getCompanyBenefits" :key="benefit.id">
                                      <div class="sticky-check">
                                        <label class="custom-check-box">
                                          <input type="checkbox" :value="benefit.id" name="benefits" v-model="employeeAssignedBenefts" />
                                          <span class="radio-check text-capitalize"> {{ benefit.name }} </span>
                                        </label>
                                          <span class="radio-check"> {{ benefit.amount }} </span>
                                      </div>
                                    </li>
                                </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <a
                        href="javascript:void(0)"
                        class="btn btn-outline-warning btn-sm f-bold"
                        data-dismiss="modal"
                      >Cancel</a>
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm f-bold"
                        data-dismiss="modal"
                        @click="assignBenefits"
                      >Save</button>
                  </div>
              </div>
          </div>
      </div>
      <!-- end add benefit modal -->

        <!--edit benifits-->
      <!-- benefit edit modal -->
      <div
        class="modal fade write-msg-model creat-employee-modal"
        id="benefit-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="write-msg-modelLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title">
                <h5>Update Benefit</h5>
              </div>
              <button
                type="button"
                class="close"
                ref="closeModal"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span class="ico-cross"></span>
              </button>
            </div>
            <div class="modal-body">
              <div class="scrolling">
                <div class="inputs-wrapper">
                  <div class="inputs-holder">
                    <div class="field-col">
                      <label>Benefit Name:</label>
                      <input
                        type="text"
                        class="form-control text-capitalize"
                        v-model="benefitName"
                      />
                    </div>
                    <div class="field-col">
                      <label>Benefit Amount</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="BenefitAmount"
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a
                href="javascript:void(0)"
                class="btn btn-outline-warning btn-sm f-bold"
                data-dismiss="modal"
              >Cancel</a
              >
              <button
                type="button"
                class="btn btn-outline-primary btn-sm f-bold"
                data-dismiss="modal"
                @click="UpdateBenefit"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
        </div>
        <createEmployeeModal></createEmployeeModal>
    </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import createEmployeeModal from "../Employees/createEmployeeModal";
import DatePicker from "vue2-datepicker";
import employeeSidebar from "../Employees/employeeSidebar";
export default {
  name: "userProfile",
  components: {
    Multiselect,
    createEmployeeModal,
    DatePicker,
    employeeSidebar
  },
  data() {
    return {
      benefitName:'',
      BenefitAmount:'',
      benefitId:'',
      employeeData: [],
      getCompanies: this.$store.getters.getUser.companies,
      getCompanyBenefits: this.$store.getters.getSelectedCompany.companyBenefits,
      jobRoles: this.$store.getters.getSelectedCompany.jobRoles,
      selectedCompanyName: this.$store.getters.getSelectedCompany.name,
      currency: this.$store.getters.getSelectedCompany.currency,
      company_id: this.$store.getters.getSelectedCompany.id,
      employeeJobRole: [],
      checkAttendance: false,
      remoteWork: "",
      managerAccess: "",
      employeeAssignedBenefts:[],
      salary_period2: 30,
      type: "password",
      fname: "",
      lname: "",
      showNewBtn: false,
      leaveValidate: "",
      employeeAllownces: [],
      fullName: "",
      employeeId        : this.$store.getters.getEmployeeProfileId,
      user  : this.$store.getters.getUser,
    };
  },
  mounted() {
    //console.log(this.getCompanyBenefits,'getCompanyBenefits');

    this.getEmployeeData();
    this.getAllownces();
    $(".mx-input").addClass("picker-input");
  },
  methods: {
    openBenefitModal(id) {
        let benefit = this.employeeAllownces.filter((item) => item.id === id)[0];
      //console.log(id,benefit);
      this.benefitName = benefit.companyBenefit.name;
        this.BenefitAmount = benefit.benefits_amount;
        this.benefitId = benefit.id;

    },
    assignBenefits(){
      // console.log(benefits,'changed benefits')
      if(this.employeeAssignedBenefts.length !== 0){
        this.$axios({
                method: "POST",
              data: {
                benefitId:this.employeeAssignedBenefts,
                company_id:this.company_id,
                employee_id: this.employeeId.id,
                benefit: this.getCompanyBenefits
                },
              url: this.$AddEmployeeBenefit,
              headers: this.getAuthHeader(),
            }).then((res) => {
              if (res.data.status == 200) {
                $root.$toast.success(res.data.message);
                $('#add-company-benefit').modal('hide');
                this.getAllownces();
              }
            });
      }else{
        $root.$toast.error('Select benefit');
        this.getAllownces();
      }
    //  console.log(this.employeeAssignedBenefts.length,'employeeAssignedBenefts')
    },
    UpdateBenefit() {
      this.$axios({
        method: "POST",
        data: {
          name: this.benefitName,
          amount: this.BenefitAmount,
          id: this.benefitId,
          company_id:this.company_id,
        },
        url: this.$UpdateEmployeeBenefit,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.$store.commit("setUser", res.data.result);
          $root.$toast.success(res.data.message);
          $("#benefit-name-" + this.benefitId).text(this.benefitName);
          $("#benefit-amount-" + this.benefitId).text(this.BenefitAmount);
          $("#benefit-modal").modal("hide");
          this.getAllownces();
        }
      });
    },
    delAllownce(empId, benefitId) {
      // var userId = this.$store.getters.getUser.companies[0].user_id;
      var paramss = {
        employee_id: empId,
        id: benefitId,
        // user_id: userId
      };
      if (confirm("Are you sure you want to delete this benefit?")) {
        this.$axios
          .get(this.$deleteAllownces, {
            params: paramss,
            headers: this.getAuthHeader(),
          })
          .then((response) => {
            if (response.data.status == 200) {
              $root.$toast.success(response.data.message);
              this.getAllownces();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getAllownces() {
      var comp_id = this.$store.getters.getSelectedCompany.id;
      var id = this.employeeId.id;
      var paramss = {
        employee_id: id,
        company_id: comp_id,
      };

      this.$axios
        .get(this.$getAllAllownces, {
          params: paramss,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.employeeAllownces = response.data.result;
            this.employeeAssignedBenefts = this.employeeAllownces.map(item => item.benefits_id);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    leavesCheckforHalf(event) {
      var decimal = event.target.value - Math.floor(event.target.value) !== 0;
      if (
        (decimal && event.target.value === "2.5") ||
        (decimal && event.target.value === "1.5")
      ) {
        this.employeeData.monthly_allow_leaves = event.target.value;
        this.leaveValidate = "";
        this.checkAttendance = false;
      } else {
        if (decimal) {
          this.leaveValidate = "invalid";
          this.checkAttendance = true;
        } else {
          this.employeeData.monthly_allow_leaves = event.target.value;
          this.leaveValidate = "";
          this.checkAttendance = false;
        }
      }
    },
    calc_hrs_rate() {
      if (this.employeeData.weekly_hours !== "") {
        this.employeeData.monthly_hours = this.employeeData.weekly_hours * 4;
      } else {
        this.employeeData.monthly_hours = 0;
      }

      this.employeeData.hourly_rate =
        Math.round(
          this.employeeData.basic_salary / (this.employeeData.weekly_hours * 4)
        ) || 0;
      if (this.employeeData.hourly_rate === Infinity)
        this.employeeData.hourly_rate = 0;
    },
    updateEmployeeProfile(e) {
      this.employeeData.empl_role = this.employeeJobRole.map((id) => id.id);
      this.employeeData["remoteWork"] = this.remoteWork;
      this.employeeData["managerAccess"] = this.managerAccess;
      this.employeeData["company"] = this.employeeData.employee_company_id;
      this.employeeData["fname"] = this.fname;
      this.employeeData["lname"] = this.lname;
      this.$axios({
        method: "PUT",
        data: this.employeeData,
        url: this.$EmployeeUpdate,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          // this.$router.go(0);
          $("#profile-employee").modal("hide");
          $("#emergency-employee").modal("hide");
          $("#paymentInfo-employee").modal("hide");
          this.getEmployeeData();
          $root.$toast.success("Profile updated!");
        }
      });
    },
    getEmployeeData() {
      this.employeeJobRole = [];
      var id = this.$route.params.id;
      this.$axios({
        method: "get",
        params: {
          user_id: id,
          company_id: this.$store.getters.getSelectedCompany.id,
        },
        url: this.$GetEmployeeProfile,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.employeeData = res.data.result[0];
          this.employeeData.employment_date = new Date(
            this.employeeData.employment_date
          );
          // let yyy = employmentDate.getFullYear();
          // let mm = employmentDate.getMonth() + 1;
          // let dd = employmentDate.getDate();
          // if(mm<10) mm = '0'+mm;
          // if(dd<10) dd = '0'+dd;
          // this.employeeData.employment_date = mm +'-'+dd+'-'+yyy;
          // this.employeeData.employment_date = '07/14/2022';
          this.remoteWork = this.employeeData.remoteWork;
          this.managerAccess = this.employeeData.managerAccess;
          this.$store.commit("setEmployeeProfileId", this.employeeData);
          this.employeeData.employeeJobType.map((type) =>
            this.employeeJobRole.push(type.get_job_roles)
          );
          this.fullName =
            this.employeeData.name.substring(0, 1).toUpperCase() +
            this.employeeData.name.substring(1);
          let splitName = this.employeeData.name.split(" ");
          this.fname = splitName[0];
          this.lname = splitName[1];
          this.showNewBtn =
            this.employeeData.lastId == this.$route.params.id ? true : false;
        }
      });
    },
    getCompanyRoles(event, empl_id) {
      var comp_id = this.$store.getters.getSelectedCompany.id;
      this.employeeJobRole = [];
      if (comp_id == event.target.value) {
        this.employeeData.employeeJobType.map((type) =>
          this.employeeJobRole.push(type.get_job_roles)
        );
      } else {
        this.employeeJobRole = [];
      }
      this.$axios({
        method: "get",
        params: {
          user_id: empl_id,
          company_id: comp_id,
        },
        url: this.$CheckEmployeeAttendance,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 402) {
          $root.$toast.error(res.data.message);
          this.checkAttendance = true;
        } else if (res.data.status == 200) {
          this.checkAttendance = false;
          this.jobRoles = this.getCompanies.filter(
            (val) => val.id == event.target.value
          )[0].jobRoles;
        }
      });
    },
    activeMe(activeBtn) {
      var deactivateBtn = "";

      if (activeBtn == "yes") {
        this.managerAccess = "yes";
        deactivateBtn = "no";
      } else {
        this.managerAccess = "no";
        deactivateBtn = "yes";
      }

      $("." + deactivateBtn).removeClass("btn-primary");
      $("." + activeBtn).addClass("btn-primary");
    },
    salaryActiveBtn(activeBtn) {
      if (activeBtn == "yes") {
        this.remoteWork = "yes";
        $("#salary-no").removeClass("btn-primary");
        $("#salary-yes").addClass("btn-primary");
      } else {
        this.remoteWork = "no";
        $("#salary-yes").removeClass("btn-primary");
        $("#salary-no").addClass("btn-primary");
      }
    },
    pswdShowHide() {
      if (this.type == "password") {
        this.type = "text";
        $(".pswdShowHideCls").addClass("show-pass");
      } else {
        this.type = "password";
        $(".pswdShowHideCls").removeClass("show-pass");
      }
    },
  },
};
</script>

<style scoped>
.input-wrapper {
  position: relative;
}

.input-wrapper .form-control {
  padding-right: 20px;
}

.input-wrapper .ico-eye_selected {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: auto;
  right: 5px;
  cursor: pointer;
}

.textRed {
  color: red;
}

.date-picker-width {
  /* height: 100px; */
  width: 100% !important;
}

.picker-input {
  border: 0 !important;
  background: #f6f6f6 !important;
  box-shadow: none !important;
  height: 50px !important;
}
</style>
